import emailjs from '@emailjs/browser';
import { trackFormSubmission } from '../utils/analytics';

// EmailJS Configuration
const EMAILJS_SERVICE_ID = 'YOUR_EMAILJS_SERVICE_ID'; // Replace with your EmailJS service ID
const EMAILJS_TEMPLATE_ID = 'YOUR_EMAILJS_TEMPLATE_ID'; // Replace with your EmailJS template ID
const EMAILJS_PUBLIC_KEY = 'YOUR_EMAILJS_PUBLIC_KEY'; // Replace with your EmailJS public key

// Initialize EmailJS
emailjs.init(EMAILJS_PUBLIC_KEY);

// Email service for appointment bookings
export const sendAppointmentEmail = async (formData) => {
  try {
    // Prepare email template parameters
    const templateParams = {
      to_email: 'premierdentalnepal@gmail.com',
      from_name: formData.name,
      from_email: 'noreply@premierdental.com.np',
      phone: formData.phone,
      service: formData.service,
      message: formData.message || 'No additional message',
      appointment_date: new Date().toLocaleDateString('en-US', {
        timeZone: 'Asia/Kathmandu',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      }),
      clinic_name: 'Premier Dental Clinic',
      clinic_address: 'Ram Devi Complex, Suryabinayak, Bhaktapur',
      clinic_phone: '+977 981-3538101'
    };

    // Send email using EmailJS
    const response = await emailjs.send(
      EMAILJS_SERVICE_ID,
      EMAILJS_TEMPLATE_ID,
      templateParams
    );

    // Track successful form submission
    trackFormSubmission('appointment_booking_success');

    return {
      success: true,
      message: 'Appointment request sent successfully!',
      response: response
    };

  } catch (error) {
    console.error('Email sending failed:', error);
    
    // Track failed form submission
    trackFormSubmission('appointment_booking_failed');

    return {
      success: false,
      message: 'Failed to send appointment request. Please call us directly.',
      error: error
    };
  }
};

// Send confirmation email to patient (optional)
export const sendPatientConfirmation = async (formData) => {
  try {
    const templateParams = {
      to_email: formData.email || '', // If patient provides email
      patient_name: formData.name,
      service_requested: formData.service,
      clinic_name: 'Premier Dental Clinic',
      clinic_phone: '+977 981-3538101',
      clinic_address: 'Ram Devi Complex, Suryabinayak, Bhaktapur',
      confirmation_message: `Dear ${formData.name}, thank you for your appointment request. We will contact you shortly to confirm your appointment.`
    };

    await emailjs.send(
      EMAILJS_SERVICE_ID,
      'patient_confirmation_template', // Different template for patient confirmation
      templateParams
    );

    return { success: true };
  } catch (error) {
    console.error('Patient confirmation email failed:', error);
    return { success: false, error };
  }
};

// Alternative: Direct email sending (requires backend)
export const sendEmailViaBackend = async (formData) => {
  try {
    const response = await fetch('/api/send-appointment-email', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        to: 'premierdentalnepal@gmail.com',
        subject: `New Appointment Request - ${formData.service}`,
        patientName: formData.name,
        phone: formData.phone,
        service: formData.service,
        message: formData.message,
        timestamp: new Date().toISOString()
      })
    });

    const result = await response.json();
    
    if (response.ok) {
      trackFormSubmission('appointment_booking_success');
      return {
        success: true,
        message: 'Appointment request sent successfully!'
      };
    } else {
      throw new Error(result.message || 'Failed to send email');
    }

  } catch (error) {
    console.error('Backend email sending failed:', error);
    trackFormSubmission('appointment_booking_failed');
    
    return {
      success: false,
      message: 'Failed to send appointment request. Please call us directly.',
      error: error
    };
  }
};

// Validate form data before sending
export const validateAppointmentForm = (formData) => {
  const errors = [];

  if (!formData.name || formData.name.trim().length < 2) {
    errors.push('Please enter a valid name (at least 2 characters)');
  }

  if (!formData.phone || formData.phone.trim().length < 10) {
    errors.push('Please enter a valid phone number (at least 10 digits)');
  }

  if (!formData.service) {
    errors.push('Please select a service');
  }

  // Phone number validation for Nepal
  const phoneRegex = /^(\+977)?[0-9]{10}$/;
  const cleanPhone = formData.phone.replace(/[-\s]/g, '');
  if (!phoneRegex.test(cleanPhone)) {
    errors.push('Please enter a valid Nepali phone number');
  }

  return {
    isValid: errors.length === 0,
    errors: errors
  };
};

// Format appointment data for email
export const formatAppointmentData = (formData) => {
  return {
    patientName: formData.name.trim(),
    phone: formData.phone.replace(/[-\s]/g, ''),
    service: formData.service,
    message: formData.message?.trim() || 'No additional message',
    requestTime: new Date().toLocaleString('en-US', {
      timeZone: 'Asia/Kathmandu',
      dateStyle: 'full',
      timeStyle: 'short'
    }),
    source: 'Website Contact Form'
  };
};
